<template>
  <permission-gate
    v-slot="{ canEdit }"
    moduleKey="usuarios"
  >
    <main-breadcrumb
      :items="items"
      showBackButton
    ></main-breadcrumb>
    <main-buttons-bar :align="'space-between'">
      <template #left>
        <custom-title>Listado de usuarios</custom-title>
      </template>
      <template #right>
        <el-tooltip
          v-if="!canEdit"
          content="El usuario no posee permisos de edición"
          placement="top"
        >
          <el-button
            type="primary"
            size="default"
            :icon="IconAdd"
            disabled
          >
            Nuevo usuario
          </el-button>
        </el-tooltip>
        <template v-else>
          <el-button
            type="primary"
            size="default"
            :icon="IconAdd"
            @click="openModal"
            >Nuevo usuario</el-button
          >
          <modal-new-user
            v-model="modalVisible"
            @closed="handleModalClosed"
          ></modal-new-user>
        </template>
      </template>
    </main-buttons-bar>
    <users-filters></users-filters>
    <custom-table
      :requestApi="findAllUsersHTTP"
      :pathDetail="'/page/users/detail'"
      :pathEdit="'/page/users/edit'"
      :paramId="'id'"
      :data="users"
      :columns="columns"
    ></custom-table>
  </permission-gate>
</template>

<script setup>
import {
  ref,
  onBeforeMount,
} from 'vue';
import { storeToRefs } from 'pinia';
import { useUserStore } from './../stores/user_store.js';
import MainBreadcrumb from '@/shared/layout/main/main_breadcrum.vue';
import MainButtonsBar from '@/shared/layout/main/buttons_bar/main_buttons_bar.vue';
import CustomTable from '@/shared/components/custom_table.vue';
import CustomTitle from '@/shared/components/custom_title.vue';
import IconAdd from '~icons/mdi/add';
import UsersFilters from './user_filters.vue';
import ModalNewUser from './modal_new_user.vue';
import PermissionGate from '@/shared/components/permission_gate.vue';
const userStore = useUserStore();
const { firstUsers, findAllUsersHTTP, resetUser } = userStore;
const { users } = storeToRefs(userStore);

// local state
const items = [
  { label: 'Inicio', to: '/dashboard', replace: false },
  { label: 'Listado', to: null, replace: false },
];

const columns = [
  { field: 'Codigo', label: 'Código', width: 100, sortable: true, isVisible: true },
  { field: 'Usuario', label: 'Usuario', width: 200, sortable: true, isVisible: true },
  { field: 'Nombre', label: 'Nombre', width: 200, sortable: true, isVisible: true },
  { field: 'Apellido', label: 'Apellido', width: 200, sortable: true, isVisible: true },
  { field: 'Email', label: 'Email', width: 200, sortable: true, isVisible: true },
  { field: 'TelefonoCelular', label: 'Celular', width: 150, sortable: true, isVisible: true },
  { field: 'TelefonoLinea', label: 'Tel. Línea', width: 150, sortable: true, isVisible: true },
  { field: 'Interno', label: 'Interno', width: 100, sortable: true, isVisible: true },
  { field: 'roles_concat', label: 'Roles', width: 250, sortable: true, isVisible: true },
  { field: 'Activo', label: 'Activo', width: 100, sortable: true, isVisible: true },
];
const modalVisible = ref(false);

const openModal = () => {
  modalVisible.value = true;
};

const handleModalClosed = () => {
  modalVisible.value = false;
};

onBeforeMount(async () => {
  await firstUsers();
  resetUser();
});
</script>

<style scoped></style>
